import _ from 'lodash';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { CoreModule } from 'app/core/core.module';
import { MdbAutocompleteModule } from 'mdb-angular-ui-kit/autocomplete';
import { CommonModule } from '@angular/common';
import { GoogleMapsAutocompleteModule } from 'app/google-maps-autocomplete/google-maps-autocomplete.module';
import { NgxCurrencyDirective } from 'ngx-currency';

@Component({
  standalone:true,
  selector: 'app-volunteer-status-cell',
  templateUrl: './volunteer-status-cell.component.html',
  styleUrls: ['./volunteer-status-cell.component.scss'],
  imports:[FormsModule,ReactiveFormsModule,MdbSelectModule,CoreModule,CommonModule,MdbAutocompleteModule,GoogleMapsAutocompleteModule, NgxCurrencyDirective]
})
export class VolunteerStatusCellComponent implements OnInit {
    @Input()
    public data: any = {};

    public volunteerStatus: string = null;

    constructor() { }

    ngOnInit(): void {
      if(this.data.volunteerStatus === 1 && this.data.userStatus !== 0) {
        this.data.volunteerStatus = 2;
      }
      this.volunteerStatus = this.getVolunteerStatusString(this.data);
    }

    getVolunteerStatusString(volunteer) {
      switch(volunteer.volunteerStatus) {
        case 1:
          return "Active"
        case 2:
          return "Pending"
        case 3:
          return "Deleted"
        default:
          return "Unknown"
      }
    }
}
